import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORE_KEY = "ht_cookie_ack";

export default function CookieNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORE_KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORE_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60]" data-testid="cookie-notice">
      <div className="bg-[#0A2540] text-white rounded-[1.5rem] shadow-2xl border border-white/10 p-6">
        <div className="flex items-start gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#FF7A1A] text-white shrink-0">
            <Cookie size={20} />
          </span>
          <div>
            <h3 className="font-heading font-semibold text-white">A note on cookies</h3>
            <p className="mt-1.5 text-sm text-[#CBD5E1] leading-relaxed">
              We only use essential storage to keep the site working (like remembering your timetable choices).
              We don't use tracking or advertising cookies. See our{" "}
              <Link to="/privacy" className="text-[#38BDF8] font-semibold hover:underline">Privacy Policy</Link>.
            </p>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={accept}
            className="bg-[#FF7A1A] text-white font-bold px-6 py-2.5 rounded-full hover:-translate-y-0.5 transition-all duration-300"
            data-testid="cookie-accept"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
